module.exports = __webpack_public_path__ + "static/media/check-red.35755b7e.svg";